/**
 * 针对Label类型单做一个小组件，展示文本
 * 换行时组件内部更新State，刷新字体
 */
import React from 'react';
import { Text } from 'react-native';
import theme from '@qnpm/q-theme';
const { responsive: { scale } } = theme;
const LabelItem = (props) => {
    const [fontSize, setFontSize] = React.useState(scale(14, props.needScale));
    const [lines, setLines] = React.useState(0);
    return (<Text style={[props.style, { fontSize: fontSize, textAlign: 'center' }]} numberOfLines={lines} onLayout={(event) => {
        const { height } = event.nativeEvent.layout;
        if (height >= 20) {
            setFontSize(scale(12, props.needScale));
            setLines(2);
        }
    }}>
            {props.value}
        </Text>);
};
export default LabelItem;
